import type { CatalogEntry } from "@/platform/catalog";
import type { Article } from "@/platform/compendium";

// The single source of truth for a route's browser-tab <title>. Both the build-time prerender
// (which bakes a static <title> into each page's HTML) and the client (which re-applies the title
// on every client-side navigation, since the router never touches document.title) derive titles
// here, so the tab text can never drift from the page you are on.

const GAME_LABELS: Record<string, string> = { sc2: "StarCraft II" };

/** The display name for a game id (sc2 -> StarCraft II), or the id itself when unmapped. */
export const gameLabel = (id: string): string => GAME_LABELS[id] ?? id;

/** The homepage / SPA-shell tab title. */
export const HOMEPAGE_TITLE = "Keylens";

/** The Compendium landing (/thecore) tab title. */
export const COMPENDIUM_LANDING_TITLE = "TheCore | Keylens";

/** One Preset's tab title: the setup name, its game, and the brand. */
export function presetTitle(entry: Pick<CatalogEntry, "name" | "game">): string {
  return `${entry.name} - ${gameLabel(entry.game)} hotkeys | Keylens`;
}

/** One Compendium Article's tab title. */
export function articleTitle(article: Pick<Article, "title">): string {
  return `${article.title} | TheCore | Keylens`;
}
